import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "share-skeleton" }
const _hoisted_2 = { class: "owner" }
const _hoisted_3 = { class: "owner-data" }
const _hoisted_4 = { class: "description" }

export function render(_ctx, _cache) {
  const _component_Skeleton = _resolveComponent("Skeleton")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Skeleton, {
        shape: "circle",
        size: "5.6rem",
        style: {"border-radius":"50%"}
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Skeleton, {
          class: "name",
          width: "14.6rem",
          height: "1.8rem"
        }),
        _createVNode(_component_Skeleton, {
          class: "email",
          width: "17.6rem",
          height: "1.6rem"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Skeleton, {
        class: "name",
        width: "43.2rem",
        height: "1.5rem"
      })
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "actions" }, null, -1 /* HOISTED */))
  ]))
}